<div class="group/item h-[48px]" cardItem>
  <span cardItemTitle>{{ indicateur().nom }}</span>
  @if (peutModifier()) {
    <div class="py-xxs invisible group-hover/item:visible" cardItemActions>
      <button
        [hlmDropdownMenuTrigger]="actionsIndicateurMenu"
        [hlmDropdownMenuTriggerData]="{ $implicit: { item: indicateur() } }"
        (click)="$event.stopPropagation()"
        hlmBtn
        variant="ghost"
      >
        <ng-icon name="lucideEllipsisVertical" />
      </button>
    </div>
  }
</div>

<ng-template #actionsIndicateurMenu let-ctx>
  <hlm-dropdown-menu hlmDropdownMenuItem>
    @for (action of indicateurActions; track $index) {
      <button (triggered)="action.action(ctx.item)" hlmDropdownMenuItem>
        <ng-icon [name]="action.icon" />
        {{ action.label }}
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>
